import React, { useRef, useState } from 'react';

// import your RTK Query hook

import dayjs from 'dayjs';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import Slider from 'react-slick';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../../src/store';
import { useUpdateReportForFieldNumberMutation } from '../../../../services/mVPGraphQlService';
import { showAlert } from '../../../../services/alert';
import EditIcon from '@mui/icons-material/Edit';
const getInitials = (name) => {
  return name?.trim().charAt(0).toUpperCase();
};

const getAvatarColor = (name) => {
  const colors = [
    'rgba(248, 210, 210, 1)',
    'rgba(253, 222, 195, 1)',
    'rgba(204, 238, 246, 1)',
    'rgba(210, 211, 248, 1)',
    'rgba(241, 210, 248, 1)',
    'rgba(216, 234, 205, 1)',
    'rgba(245, 243, 190, 1)',
    'rgba(211, 223, 240, 1)',
  ];
  const index = name?.charCodeAt(0) % colors.length;
  return colors[index];
};

const getAvatarTextColor = (name) => {
  const colors = [
    'rgba(197, 73, 73, 1)',
    'rgba(203, 117, 41, 1)',
    'rgba(53, 155, 178, 1)',
    'rgba(103, 106, 209, 1)',
    'rgba(190, 101, 211, 1)',
    'rgba(85, 133, 56, 1)',
    'rgba(165, 160, 29, 1)',
    'rgba(62, 98, 149, 1)',
  ];
  const index = name?.charCodeAt(0) % colors.length;
  return colors[index];
};

const ReportsCard: React.FC<{
  thread: any;
  fieldId: number;
  handleRefetch: any;
}> = ({ thread, fieldId, handleRefetch }) => {
  const user = useSelector(
    (state: RootState) => state?.authUser
  );

  const [isAddingNote, setIsAddingNote] = useState(false);
  const [isEdutingNote, setIsEditingNote] = useState(false);
  const [noteText, setNoteText] = useState('');
  const [editingNoteId, setEditingNoteId] = useState(null);
  const [editedText, setEditedText] = useState('');
  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const threadRef = useRef(null);
  const dispatch = useDispatch();

  const [UpdateReportForFieldNumber] =
    useUpdateReportForFieldNumberMutation();
  const handleAddNote = (
    noteText: string,
    data: { reportId: number }
  ) => {
    const obj = {
      fieldNo: fieldId,
      reportId: data.reportId,
      reportElement: {
        elementType: 'TEXT_ONLY',
        elementValue: { text: noteText },
        createdActorTrace: {
          actorId: {
            actorId: user?.userId,
            actorName: user?.userName,
            actorType: user?.role,
          },
          actorTime: {
            seconds: Math.floor(Date.now() / 1000),
          },
        },
      },
    };

    UpdateReportForFieldNumber(obj)
      .unwrap()
      .then((response) => {
        const statusResponse =
          response?.data?.UpdateReportForFieldNumber
            ?.responseStatus;

        if (statusResponse?.status === 'SUCCESS') {
          handleRefetch();
        }
      });
  };

  const handleEditNote = (data, noteId, newText) => {
    const obj = {
      fieldNo: fieldId,
      reportId: data.reportId,
      reportElement: {
        elementId: noteId,
        elementType: 'TEXT_ONLY',
        elementValue: { text: newText },
        createdActorTrace: {
          actorId: {
            actorId: user?.userId,
            actorName: user?.userName,
            actorType: user?.role,
          },
          actorTime: {
            seconds: Math.floor(Date.now() / 1000),
          },
        },
      },
    };

    UpdateReportForFieldNumber(obj)
      .unwrap()
      .then((response) => {
        const statusResponse =
          response?.data?.UpdateReportForFieldNumber
            ?.responseStatus;

        if (statusResponse?.status === 'SUCCESS') {
          if (statusResponse.errorMessages?.length > 0) {
            dispatch(
              showAlert({
                content:
                  statusResponse.errorMessages.join(', '),
                severity: 'error',
              })
            );
          } else {
            handleRefetch();
          }
        }
      })
      .catch((error) => {
        console.error('Error updating note:', error);
        dispatch(
          showAlert({
            content:
              'Failed to update the note. Please try again.',
            severity: 'error',
          })
        );
      });
  };
  const handleSaveNote = () => {
    if (noteText.trim()) {
      handleAddNote(noteText, thread);
      setNoteText('');
      setIsAddingNote(false);
    }
  };
  const handleEditClick = (note) => {
    setEditingNoteId(note.elementId);
    setEditedText(note.elementValue.text);
    setIsEditingNote(true);
  };

  const handleSaveEdit = (note) => {
    handleEditNote(thread, note.elementId, editedText);
    setEditingNoteId(null);
    setIsEditingNote(false);
  };
  const handleImageClick = (images, index) => {
    setSelectedImages(images);
    setSelectedIndex(index);
    setOpenModal(true);
  };

  //   const funonclick = () => {
  //     setIsOpen(!isOpen);
  //   };
  const settings = {
    initialSlide: selectedIndex,
    arrows: true,
    dots: true,
    infinite: selectedImages.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // nextArrow: <NextArrow />,
    // prevArrow: <PrevArrow />,
  };

  return (
    <div
      className="thread-container"
      ref={threadRef}
      style={{ width: '500px', overflowY: 'auto' }}>
      <div>
        <div className="messages">
          {thread?.instructions != '' && (
            <div style={{ marginBottom: 5 }}>
              <div className="message-header">
                <div
                  className="avatar-initials"
                  style={{
                    backgroundColor: getAvatarColor(
                      thread?.createdActor?.actorName
                    ),
                    color: getAvatarTextColor(
                      thread?.createdActor?.actorName
                    ),
                  }}>
                  {getInitials(
                    thread?.createdActor?.actorName
                  )}
                </div>
                <p className="user-info">
                  <span className="user-name">
                    {thread?.createdActor?.actorName}
                  </span>
                  <span className="dot">•</span>
                  <span className="date">
                    {dayjs(
                      thread.createdTime?.seconds
                        ? thread.createdTime?.seconds * 1000
                        : 0
                    ).format('DD/MM/YYYY')}
                  </span>
                </p>
              </div>
              <p className="message-text">
                {thread?.instructions}
              </p>
            </div>
          )}

          {thread.reportElements?.map((msg, index) => (
            <div key={index} className="message">
              {/* Message Header */}
              <div className="message-header">
                <div
                  className="avatar-initials"
                  style={{
                    backgroundColor: getAvatarColor(
                      msg?.createdActorTrace?.actorId
                        ?.actorName
                    ),
                    color: getAvatarTextColor(
                      msg?.createdActorTrace?.actorId
                        ?.actorName
                    ),
                  }}>
                  {getInitials(
                    msg?.createdActorTrace?.actorId
                      ?.actorName
                  )}
                </div>
                <p className="user-info">
                  <span className="user-name">
                    {
                      msg?.createdActorTrace?.actorId
                        ?.actorName
                    }
                  </span>
                  <span className="dot">•</span>
                  <span className="date">
                    {dayjs(
                      msg?.createdActorTrace?.actorTime
                        ?.seconds
                        ? msg?.createdActorTrace?.actorTime
                            ?.seconds * 1000
                        : 0
                    ).format('DD/MM/YYYY')}
                  </span>
                </p>
              </div>

              {editingNoteId === msg.elementId &&
              isEdutingNote ? (
                <div className="note-box">
                  <textarea
                    className="note-input"
                    value={editedText}
                    onChange={(e) =>
                      setEditedText(e.target.value)
                    }
                  />
                  <div className="note-actions">
                    <button
                      className="cancel"
                      onClick={() =>
                        setIsEditingNote(false)
                      }>
                      Cancel
                    </button>
                    <button
                      className="save"
                      onClick={() => handleSaveEdit(msg)}>
                      Save
                    </button>
                  </div>
                </div>
              ) : (
                <p className="message-text">
                  {msg?.elementValue?.text}
                  {msg?.createdActorTrace?.actorId
                    ?.actorId === user?.userId &&
                    msg?.elementType == 'TEXT_ONLY' && (
                      <div className="note-actions">
                        <button
                          className="edit"
                          onClick={() =>
                            handleEditClick(msg)
                          }
                          disabled={
                            thread?.reportStatus !=
                            'REPORT_RECEIVED'
                          }>
                          <EditIcon fontSize="small" />
                        </button>
                      </div>
                    )}
                </p>
              )}

              <div>
                {msg.elementValue.s3PresignedUrlImages &&
                  msg.elementValue.s3PresignedUrlImages
                    .length > 0 && (
                    <div className="image-container">
                      {msg.elementValue.s3PresignedUrlImages
                        .slice(0, 2)
                        ?.map((image, imgIndex) => (
                          <img
                            key={imgIndex}
                            src={image}
                            alt={`Attachment ${
                              imgIndex + 1
                            }`}
                            className="message-image"
                            onClick={() =>
                              handleImageClick(
                                msg.elementValue
                                  .s3PresignedUrlImages,
                                imgIndex
                              )
                            }
                          />
                        ))}

                      {msg.elementValue.s3PresignedUrlImages
                        .length > 2 && (
                        <div
                          className="more-images"
                          onClick={() =>
                            handleImageClick(
                              msg.elementValue
                                .s3PresignedUrlImages,
                              0
                            )
                          }>
                          +
                          {msg.elementValue
                            .s3PresignedUrlImages.length -
                            2}{' '}
                          more
                        </div>
                      )}
                    </div>
                  )}
              </div>
            </div>
          ))}

          {isAddingNote && (
            <div className="message">
              <div className="message-header">
                <div
                  className="avatar-initials"
                  style={{
                    backgroundColor: getAvatarColor('You'),
                    color: getAvatarTextColor('You'),
                  }}>
                  {getInitials('You')}
                </div>
                <p className="user-info">
                  <span className="user-name">You</span>
                </p>
              </div>

              <div className="note-box">
                <textarea
                  className="note-input"
                  placeholder="Write something..."
                  value={noteText}
                  onChange={(e) =>
                    setNoteText(e.target.value)
                  }
                />
                <div className="note-actions">
                  <button
                    className="cancel"
                    onClick={() => setIsAddingNote(false)}>
                    Cancel
                  </button>
                  <button
                    className="save"
                    onClick={handleSaveNote}>
                    Save
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="header">
          <button
            className="add-note"
            style={{
              opacity:
                thread?.reportStatus != 'REPORT_RECEIVED'
                  ? '30%'
                  : '',
            }}
            onClick={() => setIsAddingNote(true)}
            disabled={
              thread?.reportStatus != 'REPORT_RECEIVED'
            }>
            + Add Note
          </button>
        </div>
        {/* )} */}
      </div>
      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        maxWidth="md"
        fullWidth>
        <DialogContent style={{ position: 'relative' }}>
          <CloseIcon
            onClick={() => setOpenModal(false)}
            style={{
              position: 'absolute',
              top: 10,
              right: 10,
              cursor: 'pointer',
              color: 'white',
              backgroundColor: 'black',
              borderRadius: '50%',
              padding: '5px',
              zIndex: 9999,
            }}
          />
          <Slider {...settings}>
            {selectedImages.map((img, i) => (
              <div key={i}>
                <img
                  src={img}
                  alt={`Slide ${i}`}
                  style={{
                    width: '100%',
                    maxHeight: '80vh',
                    objectFit: 'contain',
                  }}
                />
              </div>
            ))}
          </Slider>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ReportsCard;
